import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import facebookConnect from './components/facebookConnect';
import api from './components/api';
import handleApiResponse from './components/handleApiResponse';

const FacebookLogin = ({ language, params, subDirectory, wide, text }) => {
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [FB, setFB] = useState(null);
  const [logUserIn, setLogUserIn] = useState(false);
  const [fbConnectStatus, setFbConnectStatus] = useState({});
  useEffect(() => {
    let isCancelled = false;
    async function loadSDK() {
      let SDK = await facebookConnect.getSDK();
      if (!isCancelled) {
        if (SDK) {
          setFB(SDK);
          setIsLoaded(true);
        } else {
          SDK = await facebookConnect.loadSDK(language || 'en_GB');
          setFB(SDK);
          setIsLoaded(true);
        }
        setIsLoggingIn(true);
        const response = await facebookConnect.getLoginStatus(SDK);
        setFbConnectStatus(response);
        return setIsLoggingIn(false);
      }
      return false;
    }
    loadSDK();
    const loggedOutCookie = Cookies.get('logged_out');
    if (!loggedOutCookie) {
      setLogUserIn(true);
    }
    return () => {
      isCancelled = true;
    };
  }, [language]);
  useEffect(() => {
    if (fbConnectStatus.status == 'connected' && logUserIn) {
      setIsLoggingIn(true);
      api
        .login(params, subDirectory)
        .then((response) => handleApiResponse.success(response))
        .catch((error) => handleApiResponse.failure(error));
    }
  }, [fbConnectStatus, logUserIn, params, subDirectory]);

  async function login(event) {
    event.preventDefault();
    if (fbConnectStatus.status == 'connected') {
      setIsLoggingIn(true);
      return setLogUserIn(true);
    }
    setIsLoggingIn(true);
    return facebookConnect.login(FB).then((response) => {
      setLogUserIn(true);
      setFbConnectStatus(response);
    });
  }

  return (
    <button
      onClick={login}
      disabled={!isLoaded}
      data-testid="facebook-login"
      className={
        wide
          ? 'button button--facebook button--wide'
          : 'button button--facebook'
      }
      type="button"
    >
      <div className="button__content">
        <span className="button__icon">
          <i className="fab fa-facebook" />
        </span>
        <span className="button__text">{text}</span>
      </div>
    </button>
  );
};

FacebookLogin.defaultProps = {
  language: 'en_GB',
};

FacebookLogin.propTypes = {
  language: PropTypes.oneOf(['en_GB', 'en_US']),
  subDirectory: PropTypes.oneOf(['flatshare', 'roommate']).isRequired,
  params: PropTypes.shape({
    loginfrom_url: PropTypes.string.isRequired,
    usertype_new: PropTypes.oneOf([
      'haveashare',
      'makeashare',
      'lookingforashare',
    ]).isRequired,
    custom_password_required: PropTypes.oneOf([1, 0]),
    referred_by: PropTypes.string,
  }).isRequired,
  wide: PropTypes.bool,
  text: PropTypes.string,
};

export default FacebookLogin;
